module.exports = __webpack_public_path__ + "img/noelcouple.417c2267.png";